module.exports = "<div class=\"sidebar\">\n  <app-sidebar-header></app-sidebar-header>\n  <app-sidebar-form></app-sidebar-form>\n  <app-sidebar-nav></app-sidebar-nav>\n  <app-sidebar-footer></app-sidebar-footer>\n  <app-sidebar-minimizer></app-sidebar-minimizer>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /var/www/html/LASO/laso-client/src/app/components/app-sidebar/app-sidebar.component.html
// module id = ../../../../../src/app/components/app-sidebar/app-sidebar.component.html
// module chunks = main